/* Prepphjälpen: varukorgs-uppsälj och antalsval (quantity breaks). */
(() => {
  const SECTIONS = 'cart-drawer,cart-icon-bubble';

  // Lägg till rader i varukorgen och öppna drawern med uppdaterat innehåll.
  async function addToCart(items, { discountCode } = {}) {
    const response = await fetch(`${window.routes.cart_add_url}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items, sections: SECTIONS }),
    });
    const state = await response.json();
    if (!response.ok || state.status) throw new Error(state.description || 'add failed');

    if (discountCode !== undefined) {
      // Behåll kundens egna koder, byt bara ut paketkoder (t.ex. MYLAR2PERSONER/MYLAR4PERSONER)
      const cart = await fetch(`${window.routes.cart_url}.js`).then((r) => r.json());
      const keep = (cart.discount_codes || []).map((d) => d.code).filter((code) => !BUNDLE_CODES.has(code.toUpperCase()));
      const codes = [...keep, discountCode].filter(Boolean).join(',');
      const updated = await fetch(`${window.routes.cart_update_url}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: codes, sections: SECTIONS }),
      }).then((r) => r.json());
      if (updated.sections) state.sections = updated.sections;

      // Kassan läser rabattkoden från Shopifys discount-cookie, så sätt (eller rensa) den också
      if (discountCode) {
        await fetch(`/discount/${encodeURIComponent(discountCode)}?redirect=${encodeURIComponent(window.routes.cart_url)}`);
      } else {
        document.cookie = 'discount_code=; Max-Age=0; path=/';
      }
    }

    const drawer = document.querySelector('cart-drawer');
    if (drawer && state.sections) {
      drawer.classList.remove('is-empty');
      drawer.renderContents({ ...state, id: items[0].id });
    } else {
      window.location.href = window.routes.cart_url;
    }
  }

  function withBusy(button, task) {
    const label = button.innerHTML;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    return task()
      .catch(() => {
        button.innerHTML = button.dataset.errorText || label;
        setTimeout(() => (button.innerHTML = label), 2500);
      })
      .finally(() => {
        button.disabled = false;
        button.removeAttribute('aria-busy');
      });
  }

  // Till kassan: skicka med varukorgens rabattkoder i länken, så att de gäller även om
  // discount-cookien inte följer med (t.ex. när kassan ligger på en annan domän).
  document.addEventListener(
    'click',
    async (event) => {
      const button = event.target.closest('button[name="checkout"], a[href$="/checkout"]');
      if (!button || event.defaultPrevented) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      let url = `${window.Shopify?.routes?.root || '/'}checkout`;
      try {
        const cart = await fetch(`${window.routes.cart_url}.js`).then((r) => r.json());
        const codes = (cart.discount_codes || []).filter((d) => d.applicable).map((d) => d.code);
        if (codes.length) url += `?discount=${encodeURIComponent(codes.join(','))}`;
      } catch (error) {
        // Gå till kassan ändå
      }
      window.location.href = url;
    },
    { capture: true }
  );

  // Uppsälj i varukorgen (drawern renderas om, därför event delegation).
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-upsell-variant]');
    if (!button) return;
    withBusy(button, () =>
      addToCart([{ id: Number(button.dataset.upsellVariant), quantity: Number(button.dataset.upsellQuantity) || 1 }])
    );
  });

  // Antalsval: synka valt antal till produktformulärets quantity-fält.
  class QuantityBreaks extends HTMLElement {
    connectedCallback() {
      this.form = document.getElementById(this.dataset.form);
      if (!this.form) return;
      this.input =
        document.querySelector(`input[name="quantity"][form="${this.dataset.form}"]`) ||
        this.form.querySelector('input[name="quantity"]');
      if (!this.input) {
        this.input = Object.assign(document.createElement('input'), { type: 'hidden', name: 'quantity' });
        this.input.setAttribute('form', this.dataset.form);
        this.form.append(this.input);
      }
      this.addEventListener('change', () => this.sync());
      this.sync();
    }

    sync() {
      const checked = this.querySelector('input[type="radio"]:checked');
      if (!checked) return;
      this.input.value = checked.value;
      this.dispatchEvent(
        new CustomEvent('quantity-breaks:change', {
          bubbles: true,
          detail: { quantity: Number(checked.value), label: checked.dataset.label, price: checked.dataset.price },
        })
      );
    }
  }
  if (!customElements.get('quantity-breaks')) customElements.define('quantity-breaks', QuantityBreaks);

  // Paketval: vald nivå styr variant, antal, bonusprodukter och rabattkod.
  // Rabattkoden läggs på först vid köp, så att varukorgen aldrig får kvar en kod från en annan nivå.
  const BUNDLE_CODES = new Set();

  class BundleTiers extends HTMLElement {
    connectedCallback() {
      this.form = document.getElementById(this.dataset.form);
      if (!this.form) return;
      this.idInput = this.form.querySelector('input[name="id"]');
      this.quantityInput =
        document.querySelector(`input[name="quantity"][form="${this.dataset.form}"]`) ||
        this.form.querySelector('input[name="quantity"]');
      if (!this.quantityInput) {
        this.quantityInput = Object.assign(document.createElement('input'), { type: 'hidden', name: 'quantity' });
        this.quantityInput.setAttribute('form', this.dataset.form);
        this.form.append(this.quantityInput);
      }
      this.querySelectorAll('input[data-code]').forEach((input) => input.dataset.code && BUNDLE_CODES.add(input.dataset.code.toUpperCase()));
      this.addEventListener('change', () => this.sync());
      this.sync();

      // Fångas före temats egen formulärhanterare
      this.form.addEventListener('submit', (event) => this.onSubmit(event), { capture: true });
    }

    sync() {
      const checked = this.querySelector('input[type="radio"]:checked');
      if (!checked) return;
      if (this.idInput) this.idInput.value = checked.value;
      this.quantityInput.value = checked.dataset.quantity;
    }

    onSubmit(event) {
      const checked = this.querySelector('input[type="radio"]:checked');
      if (!checked) return;
      event.preventDefault();
      event.stopImmediatePropagation();

      const gifts = (checked.dataset.gifts || '').split(',').filter(Boolean);
      const items = [
        { id: Number(checked.value), quantity: Number(checked.dataset.quantity) || 1 },
        ...gifts.map((id) => ({ id: Number(id), quantity: 1, properties: { Bonus: 'Ingår gratis' } })),
      ];
      const button = this.form.querySelector('[name="add"]');
      withBusy(button, () => addToCart(items, { discountCode: checked.dataset.code || '' }));
    }
  }
  if (!customElements.get('bundle-tiers')) customElements.define('bundle-tiers', BundleTiers);
})();
